import { faqThemeBodySchema } from "@redotech/redo-model/faq/faq-body-schema";

export const updateTheme = {
  input: faqThemeBodySchema,
  output: faqThemeBodySchema,
};
